export class CustomerSiteTradeReference {
    customersitecode:string
    tradeReferenceId: number;
    tradeReferenceTypeCode: string;
    tradeReferenceType: string;
    personName: string;
    designation: string;
    emailId: string;
    phoneNo: string;
    experience: number;
    remarks: string;
    isTemp: boolean;
}